import { Component, OnInit } from '@angular/core'
import { NgbNavChangeEvent } from '@ng-bootstrap/ng-bootstrap'
import { IntimacoesDataService } from '../../../shared/intimacoes-data.service'
import { DetalheProtocoloIntimacoes } from './../../../shared/detalhe-protocolo-intimacoes'

@Component({
  selector: 'app-relatorio-intimacoes-protocolo',
  templateUrl: './relatorio-intimacoes-protocolo.component.html',
  styleUrls: ['./relatorio-intimacoes-protocolo.component.scss']
})
export class RelatorioIntimacoesProtocoloComponent implements OnInit {

  public protocolo: string = ''
  public detalheIntimacoes: DetalheProtocoloIntimacoes[]
  semNotificacao: any
  page = ""
  active = ''

  constructor(private dataService: IntimacoesDataService) { }

  ngOnInit() {
  }

  buscar() {
    this.detalheIntimacoes = null
    this.dataService.getBuscaProtocoloDetalhes(this.protocolo).subscribe(
      dados => {
        this.detalheIntimacoes = dados
        this.semNotificacao = dados
        if (this.semNotificacao.message != undefined)
          this.dataService.mesageHttp200(this.semNotificacao.message)
      }

      )
      this.active = ''
    }

  onNavChange(changeEvent: NgbNavChangeEvent) {
    this.page = "1"
  }


}
